import { LangDevelopmentError } from '../../localization/webmodule-common/other/development-error-lang';
import { showError } from './ui/show-error';

export class DevelopmentError extends Error {
  constructor(message?: string) {
    const newMsg = LangDevelopmentError.unexpected(message ?? '');
    super(newMsg);
  }
}

export async function showDevelopmentError(message: string | Error) {
  await showError(message instanceof Error ? message : new DevelopmentError(message));
}
